import React, { Component } from 'react';
import classNames from 'classnames';
import {
  node, string, bool, number,
} from 'prop-types';
import './Card.scss';

const Header = ({ children }) => (
  <div className="card-header" data-selector-type="card-header">
    {children}
  </div>
);

Header.defaultProps = {
  children: null,
};

Header.propTypes = {
  children: node,
};

// eslint-disable-next-line
class Content extends Component {
  render() {
    const {
      children,
      notBordered,
      className,
      dataSelectorId,
      dataSelectorType,
    } = this.props;
    return (
      <div
        className={
          classNames({
            'card-content': true,
            'not-bordered': notBordered,
          }, className)
        }
        data-selector-type={dataSelectorType || 'card-content'}
        data-selector={dataSelectorId}
      >
        {children}
      </div>
    );
  }
}

Content.defaultProps = {
  notBordered: false,
  children: null,
  className: null,
  dataSelectorId: null,
  dataSelectorType: null,
};

Content.propTypes = {
  notBordered: bool,
  children: node,
  className: string,
  dataSelectorId: string,
  dataSelectorType: string,
};

const Card = ({
  children, className, preserveShapeOnMobile, transparent, dataSelectorId, dataSelectorIndex,
  dataSelectorType,
}) => (
  <div className={classNames({ card: true, 'mobile-fullwidth-viewport': !preserveShapeOnMobile, transparent }, className)} data-selector={dataSelectorId} data-selector-index={dataSelectorIndex} data-selector-type={dataSelectorType || 'card'}>
    {children}
  </div>
);

Card.defaultProps = {
  children: null,
  className: null,
  preserveShapeOnMobile: false,
  transparent: false,
  dataSelectorId: null,
  dataSelectorIndex: null,
  dataSelectorType: null,
};

Card.propTypes = {
  children: node,
  className: string,
  preserveShapeOnMobile: bool,
  transparent: bool,
  dataSelectorId: string,
  dataSelectorIndex: number,
  dataSelectorType: string,
};

Card.Header = Header;
Card.Content = Content;

export default Card;
